import useAuth from '@/context/AuthContext';
import { useSubscriberStatuses } from '@/hooks/useSubscriberStatuses';

export const name = 'money_bfcm-mode-2025';

export function useRule(flagValue: any) {
  const { user } = useAuth();
  const userUuid = user?.attributes?.['custom:account_manager_id'];

  // Only fetch subscriber statuses when needed (presale mode with authenticated user)
  const shouldFetchStatuses = flagValue === 'presale' && !!userUuid;
  const { data: subscriberStatuses, error } = useSubscriberStatuses(
    shouldFetchStatuses ? userUuid : null,
  );

  // If flag is off, disable immediately
  if (flagValue === 'off') {
    return false;
  }

  // If flag is all, enable for everyone
  if (flagValue === 'all') {
    return true;
  }

  // For presale, check subscriber status
  if (flagValue === 'presale') {
    // User must be authenticated
    if (!userUuid) {
      return false;
    }

    // If there's an error, default to false
    if (error) {
      console.error('Error checking subscriber status:', error);
      return false;
    }

    if (!subscriberStatuses) {
      return false;
    }

    // Only enable if user is active or aged_out
    const { aged_out, active } = subscriberStatuses;
    return aged_out || active;
  }

  // Default to false for any other flag value
  return false;
}
